import React from 'react';
import { useTranslation } from 'react-i18next';

function Story({ settings }) {
  const { i18n } = useTranslation();
  const currentLang = i18n.language || 'bs';

  const getVal = (keyBs, keyEn, fallback) => {
    if (!settings) return fallback;
    const val = currentLang === 'en' ? settings[keyEn] : settings[keyBs];
    return val || settings[keyBs] || fallback;
  };

  const storyImage = settings?.storyImage || "/img/photos/hero1d.jpg";
  
  const para1 = getVal('storyPara1Bs', 'storyPara1En', 'Vjerujem da su najljepši momenti oni koji se dese spontano. Moja misija je da kroz objektiv zabilježim emociju, svjetlost i detalje koji vašu priču čine jedinstvenom.');
  const para2 = getVal('storyPara2Bs', 'storyPara2En', 'Sa godinama iskustva u fotografisanju vjenčanja, naučila sam kako prepoznati i sačuvati te dragocjene trenutke. Svako vjenčanje je nova inspiracija i nova prilika da ispričamo nešto predivno.');
  const para3 = getVal('storyPara3Bs', 'storyPara3En', 'Od prvog susreta do isporuke gotovih fotografija, trudim se da cijeli proces bude opušten i personalizovan. Vaše povjerenje mi omogućava da stvorim uspomene koje će trajati generacijama.');

  return (
    <div className="w-full min-h-[80vh] bg-[#d6c8b7] py-24 md:py-32 px-6 md:px-12 lg:px-20 border-t border-gray-100 font-sans">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {/* Image Side */}
          <div className="w-full">
            <div className="relative aspect-[3/4] overflow-hidden bg-gray-100 shadow-2xl rounded-sm">
              <img
                src={storyImage} 
                alt="Nejira Zukić - Profesionalni fotograf i videograf vjenčanja - Više od 10 godina iskustva"
                className="w-full h-full object-cover transition-all duration-1000 hover:scale-105"
              />
            </div>
          </div>

          {/* Text Side */}
          <div className="flex flex-col justify-center space-y-10 md:space-y-12">
            <div className="space-y-8 md:space-y-10">
              <p className="text-2xl md:text-3xl lg:text-4xl font-serif leading-tight text-gray-900">
                {para1}
              </p>

              <div className="space-y-6">
                <p className="text-base md:text-lg font-light leading-relaxed text-gray-600 tracking-wide">
                  {para2}
                </p>

                <p className="text-base md:text-lg font-light leading-relaxed text-gray-600 tracking-wide">
                  {para3}
                </p>
              </div>
            </div>
            
            <div className="pt-8 flex items-center gap-4">
              <div className="w-16 h-px bg-gray-900"></div>
              <span className="text-[10px] font-black uppercase tracking-[0.3em] text-gray-400">Nejira Zukić</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Story;
